import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="notifications--toast-component"
export default class extends Controller {
  static values = {
    autoDismiss: Boolean
  }

  static targets = ['progress']

  connect() {
    this.element.dataset.show = true
    if (this.autoDismissValue) this.initAutoDismiss()
  }

  close() {
    this.element.dataset.show = false
    this.timeRemaining = 0
    queueMicrotask(() => this.element.addEventListener('transitionend', this.element.remove))
  }

  initAutoDismiss() {
    this.now = Date.now()
    this.duration = 7000
    this.timeRemaining = this.duration
    this.suspended = false

    requestAnimationFrame(this.autoDismissLoop.bind(this))
  }

  autoDismissLoop() {
    const newNow = Date.now()
    const deltaTime = newNow - this.now
    this.now = newNow

    if (!this.suspended) {
      this.timeRemaining -= deltaTime
    }

    const progress = Math.max(0, (this.timeRemaining / this.duration) * 100)
    this.progressTarget.style.width = `${progress}%`

    if (progress > 0) requestAnimationFrame(this.autoDismissLoop.bind(this))
    else this.close()
  }

  pause() {
    this.suspended = true
  }

  resume() {
    this.suspended = false
  }
}
